import type { EntitlementResponse } from '../../repositories/product-repo/schemas/entitlement.zod';

export class Entitlement {
  constructor(private apiResponse: EntitlementResponse) {}

  public getKey(): string {
    return this.apiResponse.key;
  }

  public isAvailable(): boolean {
    return this.apiResponse.available;
  }

  public isAllowed(): boolean {
    return this.apiResponse.allowed;
  }

  public isBridge(): boolean {
    return this.apiResponse.bridge;
  }

  public getUsageType() {
    return this.apiResponse.allowance?.usageType ?? null;
  }

  public getUsed() {
    return this.apiResponse.allowance?.used ?? null;
  }

  public getRecurring() {
    return this.apiResponse.allowance?.recurring ?? null;
  }

  public getIndividual() {
    return this.apiResponse.allowance?.individual ?? null;
  }

  public getTotal() {
    return this.apiResponse.allowance?.total ?? null;
  }

  public getRemaining() {
    return this.apiResponse.allowance?.remaining ?? null;
  }

  public getResetValue() {
    return this.apiResponse.allowance?.resetValue ?? null;
  }

  public isUnlimited() {
    return this.apiResponse.allowance?.unlimited ?? null;
  }

  public isNotAllowed() {
    return this.apiResponse.allowance?.notAllowed ?? null;
  }

  public getReasons(): string[] {
    return this.apiResponse.reasons;
  }

  public hasReasons(): boolean {
    return this.apiResponse.reasons.length > 0;
  }

  public getExpirationDate(): string | null {
    return this.apiResponse.expirationDate;
  }

  public hasExpirationDate(): boolean {
    return this.apiResponse.expirationDate !== null;
  }

  public isExpired(): boolean {
    if (!this.apiResponse.expirationDate) {
      return false;
    }

    const expirationDate = new Date(this.apiResponse.expirationDate);
    const now = new Date();

    return expirationDate < now;
  }

  public getIsNotUsed(): boolean {
    const used = this.getUsed();

    if (used === null) return true; // not used if no allowance is returned

    return used === 0;
  }

  public isUsageExhausted(): boolean {
    const remaining = this.getRemaining();

    if (this.isUnlimited() || remaining === null) {
      return false;
    }

    return remaining <= 0;
  }
}
